"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useModal = void 0;
const react_1 = require("react");
const Context_1 = require("./Context");
const useModal = (config, deps = []) => {
    const { setConfig, show, hide, state } = (0, react_1.useContext)(Context_1.WhithModalContext);
    (0, react_1.useLayoutEffect)(() => {
        if (config)
            setConfig(config);
    }, deps);
    return {
        show,
        hide,
        setConfig,
        state
    };
};
exports.useModal = useModal;
